export { getSvgDataUrl } from './get-map-pin-svg-data-url';
export { toGlobalId } from '../../../utils';
